<template>
  <div class='other-reward'>
    <div class='type'>
      <div><img src="../../assets/img/reward/教师.png" alt=""></div>
      <div><img src="../../assets/img/reward/组织-平面.png" alt=""></div>
      <div><img src="../../assets/img/reward/组织-动画.png" alt=""></div>
    </div>
    <div class='space1'></div>
    <div class='reward'>
      <div><img src="../../assets/img/reward/教师奖品.png" alt=""></div>
      <div><img src="../../assets/img/reward/组织平面奖品.png" alt=""></div>
      <div><img src="../../assets/img/reward/组织动画奖品.png" alt=""></div>
    </div>
    <div class='space2'></div>
    <div class='partment'>
      <div>指导老师：</div>
      <div>参赛单位：</div>
      <div>参赛单位：</div>
    </div>
    <div class='space3'></div>
    <div class='college'>
      <div>罗佩欣（广东东软学院）<br>刘 &nbsp;&nbsp;&nbsp;旭（吉林动画学院）</div>
      <div>广东东软学院<br>尚道设研</div>
      <div>吉林动画学院<br>CG模型网</div>
    </div>
    <div class='space4'></div>
  </div>
</template>

<script>
export default {
  name: 'otherReward'
}
</script>

<style lang='less' scoped>
.other-reward {
  width: 1200px;
  margin: 0 auto;
  .type {
    height: 40px;
    display: flex;
    justify-content: space-between;
    >div {
      width: 320px;
      height: 48px;
    }
  }
  .space1 {
    height: 44px;
  }
  .reward {
    height: 42px;
    position: relative;
    >:nth-child(2) {
      position: absolute;
      left: 37%;
      top: 0;
    }
    >:last-child {
      position: absolute;
      left: 74%;
      top: 0;
    }
  }
  .space2 {
    height: 44px;
  }
  .partment {
    height: 15px;
    opacity: 1;
    font-size: 12px;
    font-family: 'TH';
    font-weight: bold;
    color: #94282e;
    letter-spacing: 0px;
    position: relative;
    >:nth-child(2) {
      position: absolute;
      left: 37%;
      top: 0;
    }
    >:last-child {
      position: absolute;
      left: 74%;
      top: 0;
    }
  }
  .space3 {
    height: 20px;
  }
  .college {
    height: 44px;
    font-size: 20px;
    font-family: 'TH';
    font-weight: 400;
    color: #94282e;
    letter-spacing: 1px;
    line-height: 26px;
    position: relative;
    >:nth-child(2) {
      position: absolute;
      left: 37%;
      top: 0;
    }
    >:last-child {
      position: absolute;
      left: 74%;
      top: 0;
    }
  }
  .space4 {
    height: 116px;
  }
}
</style>